<div class="permissions-grid">
	@if (!readOnly) {
		<div class="permissions-row header-row">
			@for (option of options; track option.value; let i = $index) {
				<button type="button" class="select-link" [style.grid-column]="i + 2" (click)="selectAll(option)">
					Select
				</button>
			}
		</div>
	}
	@for (claim of claims; track claim.Id) {
		<div class="permissions-row">
			<span class="display-value">{{ claim.DisplayValue }}</span>
			<mat-radio-group
				class="radio-group"
				[value]="selectedValue(claim)"
				[disabled]="readOnly"
				(change)="onValueChange(claim, $event.value)"
			>
				@for (option of options; track option.value; let i = $index) {
					@if (option.isVisible(claim)) {
						<mat-radio-button [style.grid-column]="i + 2" [value]="option.value">
							{{ option.label }}
						</mat-radio-button>
					}
				}
			</mat-radio-group>
		</div>
	}
</div>
